import { generateProducts, searchProductsLocal, paginateProducts } from '../data/productGenerator'

// Generate products once when app loads
const GENERATED_PRODUCTS = generateProducts(5000)

/**
 * Search for products based on query and filters
 * Simulates an async API request
 */
export const searchProducts = async (query, params = {}) => {
  // Simulate network delay for realistic feel
  await new Promise(resolve => setTimeout(resolve, 600))

  try {
    const filters = {
      category: params.category,
      priceRange: params.priceRange,
      minRating: params.minRating,
      maxMoq: params.maxMoq,
      inStock: params.inStock,
      tradeAssurance: params.tradeAssurance,
      verified: params.verified,
      sortBy: params.sortBy
    }

    const filteredProducts = searchProductsLocal(
      GENERATED_PRODUCTS,
      query,
      filters,
      params.lang || 'de'
    )

    return paginateProducts(filteredProducts, params.page || 1, params.limit || 24)
  } catch (error) {
    console.error('Search failed:', error)
    return {
      products: [],
      total: 0,
      totalPages: 0,
      hasMore: false
    }
  }
}

/**
 * Get a single product by ID
 */
export const getProduct = async (id) => {
  await new Promise(resolve => setTimeout(resolve, 400))

  const product = GENERATED_PRODUCTS.find(p => p.id === parseInt(id))

  if (!product) {
    console.warn(`Product with ID ${id} not found, returning fallback.`)
    return GENERATED_PRODUCTS[0]
  }

  return product
}

/**
 * Get featured products for homepage
 */
export const getFeaturedProducts = (limit = 8) => {
  const products = GENERATED_PRODUCTS
    .filter(p => p.rating >= 4.5 && p.reviews > 50)
    .sort(() => Math.random() - 0.5)
    .slice(0, limit)

  return { products }
}

/**
 * API object for compatibility
 */
export const api1688 = {
  getProduct,
  searchProducts,
  getFeaturedProducts
}